package org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_restaurant

import org.hs_soft.runmynesto.domain.model.general.TitleEnum
import org.hs_soft.runmynesto.domain.util.helper.LanguageManager

enum class KitchenInfoHeaders(
    val key: String
) : TitleEnum {
    ID(key = "id"),
    ADDITION_ID(key = "additionId"),
    MODEL(key = "model"),
    ACTIVATE(key = "isChecked"),
    TITLE(key = "name"),
    VARIANT1(key = "variant1"),
    VARIANT2(key = "variant2"),
    VARIANT3(key = "variant3"),
    VARIANT4(key = "variant4"),
    VARIANT5(key = "variant5"),
    VARIANT6(key = "variant6"),
    VARIANT7(key = "variant7"),
    VARIANT8(key = "variant8"),
    VARIANT9(key = "variant9"),
    VARIANT10(key = "variant10");

    override val title: String
        get() = LanguageManager.getCurrentStrings().let { strings ->
            when (this) {
                ID -> ""
                ADDITION_ID ->""
                MODEL -> ""
                ACTIVATE -> strings.activate
                TITLE -> strings.title
                VARIANT1 -> strings.variant1
                VARIANT2 -> strings.variant2
                VARIANT3 -> strings.variant3
                VARIANT4 -> strings.variant4
                VARIANT5 -> strings.variant5
                VARIANT6 -> strings.variant6
                VARIANT7 -> strings.variant7
                VARIANT8 -> strings.variant8
                VARIANT9 -> strings.variant9
                VARIANT10 -> strings.variant10
            }
        }
}